import OkTableConfigType from '@/@bya3/components/tables/ok-table/OkTableConfigType'
import { API_URL } from '@/constants/config'
import LocalizationService from '@/services/localization-service'

const SectionsTableConfig: OkTableConfigType = {
  mode: 'remote',
  url: `${API_URL}/admin/help/section/list`,
  rowsPath: 'sections',
  rowClickable: true,
  columns: [
    {
      label: 'help.section-name',
      field: 'locales',
      formatFn: (val: any) => LocalizationService.getTranslate(val, 'name', LocalizationService.getCurrentLocale()),
    },
    {
      label: 'fields.slug',
      field: 'slug',
    },
    {
      label: 'help.questions-count',
      field: 'questions_count',
    },
    {
      label: 'forms.actions',
      field: 'actions',
    },
  ],
  paginationOptions: {
    enabled: true,
  },
  sortOptions: {
    enabled: false,
  },
  actions: [
  ],
  filters: [
  ],
}

export default SectionsTableConfig
